import { CALL_API } from "../libraries/middleware";
import actionCreator from "../libraries/actionCreator";

export const { Actions, Constants } = actionCreator({
  getInvoiceList(storeId: number) {
    return {
      [CALL_API]: {
        method: "GET",
        path: `/store/${storeId}/invoice/list`
      }
    };
  },
  updateInvoice(storeId: number, invoiceVo: any) {
    return {
      [CALL_API]: {
        method: "PUT",
        path: `/store/${storeId}/invoice`,
        body: invoiceVo
      }
    };
  },
  deleteInvoice(storeId: number, invoiceId: number) {
    return {
      [CALL_API]: {
        method: "DELETE",
        path: `/store/${storeId}/invoice/${invoiceId}`
      }
    };
  }
});
